import React from 'react';
import { zindex } from '@monofront/theme';
import Tippy, { TippyProps } from '@tippyjs/react';
interface IPopoverProps extends TippyProps {
  isLight?: boolean;
}

/** Do not forget to import Popover Stylesheets 'tippy.js/dist/tippy.css' on the parent app when using Popover */
const Popover: React.FC<IPopoverProps> = ({
  children,
  content,
  isLight = false,
  zIndex,
  ...props
}) => {
  return (
    <>
      <Tippy
        zIndex={zIndex || zindex.popover}
        content={content}
        {...props}
        theme={isLight ? 'light' : 'dark'}
      >
        {children}
      </Tippy>
      <style jsx global>{`
        .tippy-box[data-theme~='light'] {
          background-color: var(--white);
          color: var(--black);
          border: var(--border);
          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.08);
        }

        .tippy-box[data-theme~='light'] .tippy-arrow {
          color: var(--white);
        }

        .tippy-box[data-theme~='dark'] {
          background-color: var(--clr-tertiary-2);
          color: var(--black);
          border: none;
          box-shadow: none;
        }

        .tippy-box[data-theme~='dark'] .tippy-arrow {
          color: var(--clr-tertiary-2);
        }
      `}</style>
    </>
  );
};

export default Popover;
